import {getValue, getvalue} from 'external/date-fns'
import {range, orderBy} from 'external/lodash'
import moment from 'external/moment'
import { getVideos } from 'external/youtube'
import create from 'utils/command'
import {sleep, associate, reduceByKey} from 'utils/functions' 

const hooks =  [
  {paths: ['refreshData','props/params/pageName'], resolves: [fetchTeacherAndGroupInfo, fetchAssignments, fetchRecentActivity]},
  {paths: ['refreshData','props/query/clique', 'props/query/eventCategory'], resolves: [fetchRecentActivity]},
  {paths: ['refreshData','props/params/section', 'props/query/orderBy', 'props/query/page', 'props/params/groupId/'], resolves: [fetchAssignedContent, fetchGrades]},
  {paths: ['refreshData','props/params/pageName', 'messagesSource/', 'props/params/languageId'], resolves: [fetchMessages]},
  {paths: ['refreshData','props/params/pageName', 'props/query/clique', 'props/query/eventCategory','props/query/start', 'props/query/end', 'scheduleView' ], resolves: [fetchEvents]},
]

export {hooks as default}


export async function initialFetch(...params) {
  await fetchTeacherAndGroupInfo(...params)
  await fetchAssignments(...params)
}

export async function  fetchEventCategories({state, update}) {
  const shouldFetch = state.eventCategories.length == 0
  if (shouldFetch) {
    const eventCategories = await create('schedule', 'eventCategories')()
    update({eventCategories: {$set: eventCategories}})
  }
}

async function  fetchTeacherAndGroupInfo({state, update}) {
  const shouldFetch = (state.teachers == undefined) || (state.props.params.pageName == 'my-courses')
  if (shouldFetch) {
    const [teachers, courses] = await Promise.all([
      create('student', 'myTeachers')().then(reduceByKey('id')),
      create('student', 'myCourses')().then(reduceByKey('id'))
    ])
    update({teachers: {$set: teachers}, courses: {$set: courses}})
  }
}

async function fetchAssignments({state, update}) {
  const shouldFetch = ['my-courses', 'gradebook', 'dashboard'].indexOf(state.props.params.pageName) >= 0
  if (shouldFetch) {
    const assignments = await create('student', 'myAssignments')().then(associate('id', 'type', 'count'))
    update({assignments: {$set: assignments}})
  }
}

export async function fetchAssignedContent({state, update}, {path}) {
  const {props: {query, params}} = state
  const {groupId: clique, section, pageName} = params
  if (pageName != 'my-courses' || !clique || section != 'lesson') return
  if (!path || !path.startsWith('props/query')) update({assignedContent: {$set: undefined}}) // Clear content unless is updating a query parameter
  const assignedContent = await create('student', 'searchLessons')({...query, clique})
  update({assignedContent: {$set: assignedContent}})
}

let i = 0;
export async function fetchGrades({state, update}, matches) {
  const {path} = matches
  const {gradesPageSize: pageSize, props: {query, params}} = state
  const {groupId: clique, section, pageName} = params
  // Page validation
  if (['my-courses', 'gradebook'].indexOf(pageName) < 0) return
  // Group validation
  if (!clique) return
  // PageSize validation
  if (pageSize == 0) return
  // Validate section when in my-courses
  if (pageName == 'my-courses' && section != 'grade') return
  // Clear content unless is updating a query parameter
  if (!path || !path.startsWith('props/query')) update({grades: {$set: undefined}})

  const grades = await create('student', 'searchGroupGrades')({pageSize, ...query, clique})
  update({gradesContent: {$set: grades}})

}

export async function fetchRecentActivity({state, update}) {
  const {props: {params: {pageName}, query}} = state
  if (pageName != 'dashboard') return
  const activity = await create('student', 'recentActivity')({clique: query.clique, eventCategory: query.eventCategory})
  const recentActivity = orderBy(activity, [a => getValue(a.modified)], ['desc'])
  update({recentActivity: {$set: recentActivity}})
}

export async function fetchMessages({state, update}) {
  const {props: {params}, messagesSource: source} = state
  // Page validation
  if (params.pageName != 'dashboard' || !params.languageId) return
  update({messages: {$startLoading: true}})
  const messages = await create('student', 'myMessages')({source, language: params.languageId})
  await sleep(300)
  update({messages: {$updateLoadableList: messages}})
}

export async function fetchEvents ({state, update}, matches) {

  const {path} = matches
  const {props: {query, params}} = state
  if (['schedule', 'dashboard'].indexOf(params.pageName) < 0 || !params.languageId) return
  // Clear content unless is updating a query parameter
  if (!path || !path.startsWith('props/query')) update({events: {$set: []}, eventsByDay: {$set: {}}})

  const language = params.languageId
  const start = query.start && moment(query.start).startOf('day').toISOString()
  const end = query.end && moment(query.end).endOf('day').toISOString()
  const events = await create('student', 'events')({language, ...query, start, end})
  const eventsByDay = events.reduce((days, event) => {
    const start = moment(event.start)
    const finish = moment(event.finish)
    range(Math.max(event.duration, 1)).forEach(i => {
      const day = moment(start).add(i,'days').format('YYYY-MM-DD') 
      days[day] = days[day] || [] 
      days[day].push(event)
    })
    return days
  }, {})
  update({events: {$set: events}, eventsByDay: {$set: eventsByDay}})
}
